import axios from 'axios';
import apiConfig from '../api.config';

export default function upsellUpdateChargesRequest({ hotelId, bookingIdentifier, data }) {
  const {
    integrationHubHost,
    URIs: { upsellUpdateCharges },
  } = apiConfig;

  const uri = `${integrationHubHost}${upsellUpdateCharges}?bookingIdentifier=${bookingIdentifier}`.replace(':hotelId', hotelId);

  return axios
    .put(uri, JSON.stringify({ data }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
